import {Component, OnInit, ViewChild} from '@angular/core';
import { MatSort} from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {Report} from '../models/report';
import {ReportDialogComponent} from './dialogs/report-dialog/report-dialog.component';
import {ReportService} from '../services/report.service';
import {MatPaginator} from '@angular/material/paginator';
import {Subscription} from 'rxjs';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: [ './reports.component.scss' ],
  entryComponents: [
    ReportDialogComponent
  ]
})
export class ReportsComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'name', 'edit', 'delete' ];

  constructor (
    private _reportService: ReportService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _authService: AuthService,
    private router: Router) {

    if (!this._authService.isAdmin) {
      this.router.navigate([ 'home' ]);
    }

    this.loadReports()
  }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit () {
  }

  ngOnDestroy () {
    if (this.sub)
      this.sub.unsubscribe();
  }

  loadReports () {

    this.sub = this._reportService.select()
      .subscribe((result) => {

        let array = result.map(item => {
          let entity = new Report();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.keys = item.payload.doc.data().keys;
          return entity;
        });

        this.dataSource = new MatTableDataSource(array);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      })
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(entity) {

    let data: Report = new Report();

    if (entity) {
      data = entity;
    }

    this.dialog.open(ReportDialogComponent, {
      width: '800px',
      height: '590px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }

  delete (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir este Relatório?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._reportService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete report error: " + error.message)}
          )
      }
    })
  }

}
